const classPrefix = 'head-banner'
const dataPrefix = 'data-head-banner'
const $container = document.querySelector(`[${dataPrefix}]`)


export function headBanner() {


}
